import QuizSession from './quiz-session';
import DataProvider from './data-provider';

export default class MultipleMatchController {
    constructor({ items, question }, parent) {
        this.type = 'fallingMatch';
        this.items = items;
        this.question = question;
        this.parent = parent;

        this.correctCount = 0;
        this.totalCount = this.items.length + this.items.filter(x => x.subs).reduce((a, b) => a + b.subs.length, 0);
        this.progress = 0;
        this.score = 0;
        this.failCount = 0;

        this.state = {};

        this.foobarMap = {};
        this.items.map((x, i) => {
            this.foobarMap[`target-${i}`] = x;
            this.foobarMap[`source-${i}`] = x;

            this.state[`target-${i}`] = null;
        });
    }
    getQuestion() {
        return this.question;
    }
    getTargetItems() {
        return this.items.map((x, i) => {
            return {
                id: `target-${i}`,
                label: x.target,
                image: x.image
            };
        });
    }
    getShelfItems() {
        // return this.items.map(x => x.source)
        return this.items.map((x, i) => {
            return {
                id: `source-${i}`,
                label: x.source,
                image: x.image
            };
        });
    }

    updateCorrectCount() {
        this.correctCount = 0;
        Object.entries(this.state).forEach(([targetId, sourceId]) => {
            if (!sourceId) {
                return;
            }
            const targetItem = this.items.find(item => item.target === targetId) || this.foobarMap[targetId];
            this.correctCount += 1 + (targetItem.subs || []).length;
        });
        if (this.subsession) {
            this.correctCount -= this.subsession.totalCount - this.subsession.correctCount;
        }
        this.progress = this.correctCount / this.totalCount;
        this.score = this.progress;
        this.parent && this.parent.update();
    }

    match(targetId, sourceId) {
        // NOTE: Support for both ids and labels at the moment
        let item = this.items.find(item => item.target === targetId);
        let didMatch = false;
        if (item) {
            didMatch = item.source === sourceId;
        } else {
            item = this.foobarMap[targetId];
            didMatch = item === this.foobarMap[sourceId];
        }

        // const didMatch = item.source === sourceId
        if (didMatch) {
            // this.correctCount += 1
            this.state[targetId] = sourceId;

            if (item.subs) {
                const dataProvider = new DataProvider(item.subs);
                const session = new QuizSession(dataProvider, { lives: 1 });
                session.on('update', () => {
                    this.updateCorrectCount();
                });
                session.on('end', () => {
                    if (session.correctCount < session.totalCount) {
                        this.state[targetId] = null;
                    }
                    this.subsession = null;
                    this.updateCorrectCount();
                });
                this.subsession = session;
            }
            this.updateCorrectCount();
        } else {
            this.failCount += 1;
        }
        this.parent && this.parent.update();
        return didMatch;
    }
}
